module.exports = __webpack_public_path__ + "media/images/landing/data/crime-61f8ad4fad768c4ed366fbc0bf712ac3.png";